import React from 'react'
import PlaceRecommendCardContainer from '../PlaceRecommendCardContainer'
import styles from './PlaceRecommends.scss'

function PlaceRecommends(props) {
  const { recommendPlaceIds } = props
  return recommendPlaceIds.length ? (
    <div className="place__recommends recommends">
      <style jsx>{styles}</style>
      <div className="recommends__header">你可能也喜歡</div>
      <ul className="recommends__list">
        {recommendPlaceIds.map((id, i) => {
          return <PlaceRecommendCardContainer key={i} placeId={id} />
        })}
      </ul>
    </div>
  ) : (
    <div />
  )
}

export default PlaceRecommends
